import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { AnyDocument } from '../../../../types';
import { buildDocumentChannelName } from '../../logic/buildDocumentChannelName';
import { DocumentPrivateWebsocketEvent } from '../../types/DocumentPrivateWebsocketEvent';
import { DocumentPrivateWebsocketEventPayload } from '../../types/DocumentPrivateWebsocketEventPayload';

export const useSubscribeToDocumentCalculateFailed = (
  documentId: AnyDocument['id'],
  onCalculateFailed: (
    payload: DocumentPrivateWebsocketEventPayload[DocumentPrivateWebsocketEvent.CalculateFailed],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildDocumentChannelName(documentId),
    DocumentPrivateWebsocketEvent.CalculateFailed,
    onCalculateFailed,
  );
};
